"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _config = require("webmotors-react-pj/config");
var _utils = require("webmotors-react-pj/utils");
var _store = _interopRequireDefault(require("webmotors-react-pj/frame/modal/store"));
var _style = require("webmotors-react-pj/frame/header/logged/items/group/style");
var _lang = _interopRequireDefault(require("webmotors-react-pj/i18n/lang"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var _default = _ref => {
  let {
    groupIs
  } = _ref;
  const [modalGroup, setModalGroup] = (0, _react.useState)(false);
  const {
    nomeGrupo: groupName
  } = (0, _utils.jwtGet)();
  const storeName = (0, _utils.cookieGet)('CockpitStoreName') ? {
    text: (0, _utils.cookieGet)('CockpitStoreName'),
    allStores: false
  } : {
    text: _lang.default.header.allStores,
    allStores: true
  };
  const handleModalOpen = () => {
    setModalGroup(true);
  };
  return groupIs && _react.default.createElement(_style.StyleWrapper, {
    role: "button"
  }, _react.default.createElement(_style.StyleButton, {
    allStores: storeName.allStores,
    "data-icon-click": true,
    onClick: () => handleModalOpen()
  }, _react.default.createElement(_style.StyleInfo, null, _react.default.createElement(_style.StyleGroupName, null, groupName), _react.default.createElement(_style.StyleStoreName, {
    allStores: storeName.allStores
  }, _react.default.createElement("p", null, storeName.text), _react.default.createElement(_style.StyleIcon, {
    alt: "arrow",
    "aria-hidden": "true",
    src: "".concat(_config.UrlCockpit, "/assets/img/icons/arrow-6.svg")
  })))), modalGroup && _react.default.createElement(_store.default, {
    onClose: () => setModalGroup(false)
  }));
};
exports.default = _default;